import { Component } from '@angular/core';
import { HttpService } from '../services/httpService';
import { StorageService } from '../services/StorageService';

@Component({
  selector: 'app-cabbage-card',
  templateUrl: './cabbage-card.component.html',
})
export class CabbageCardComponent {


  os;

  joinStage: boolean = false;
  email: string = "";
  code: string = "";
  loading: boolean = false;
  visitId;
  constructor(private httpService: HttpService, private localStorage: StorageService) {



  }

  joinStageOn() {


    this.joinStage = true;
    this.firstStage = false;

  }


  codeSentStage: boolean = false;
  verified: boolean = false;
  firstStage: boolean = true;
  invalidEmail: boolean = false;
  sendConfirmationEmail() {


    if (this.checkEmail(this.email) == true) {

      this.joinStage = false;
      this.loading = true;
      const request = {
        Email: this.email
      }



      this.httpService.post<any>('Store/cabbage-card-wait-list-verify', request, false).subscribe(
        resp => {


          if (JSON.parse(resp.message).message == "sent") { this.codeSentStage = true; }

          this.loading = false;

        },
        error => {
          this.loading = false;
          this.joinStage = true;
          //this.snackbarService.show('Oh no! That email or password was incorrect.');
        });

    }
    else { this.invalidEmail = true;}
  }










  success: boolean = false;







  ConfirmEmail() {

    this.codeSentStage = false;

    this.visitId = this.localStorage.get("VisitIdentifier") || 0;

    this.loading = true;
    const request = {
      Email: this.email,
      VisitId: Number(this.visitId),
      Code: this.code,
    }



    this.httpService.post<any>('Store/cabbage-card-wait-list', request, false).subscribe(
      resp => {


        if (JSON.parse(resp.message).message == "success") { this.success = true; }

        this.loading = false;

      },
      error => {
        this.loading = false;

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });



  }



  goBackToEmail() {

    this.joinStage = true;
    this.codeSentStage = false;
    this.invalidEmail = false;
  }





  checkEmail(chunk) {

    var emailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (!emailReg.test(chunk)) {
      //alert('Enter valid email');
      return false;
    }

    return true;
  }



}
